export const resumeClinicDetailsData = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const getSaturdaysInMonth = (month, year) => {
    const saturdays = [];
    const date = new Date(year, month, 1);

    // Find first Saturday
    while (date.getDay() !== 6) {
      date.setDate(date.getDate() + 1);
    }

    // Get all Saturdays in the month
    while (date.getMonth() === month) {
      const saturday = new Date(date);
      saturday.setHours(0, 0, 0, 0); // Normalize time
      saturdays.push(saturday);
      date.setDate(date.getDate() + 7);
    }

    return saturdays;
  };

  const getEventDates = () => {
    let monthToCheck = today.getMonth();
    let yearToCheck = today.getFullYear();
    let attempts = 0;
    const maxAttempts = 3; // Prevent infinite loops

    while (attempts < maxAttempts) {
      const saturdays = getSaturdaysInMonth(monthToCheck, yearToCheck);

      if (saturdays.length >= 2) {
        const secondSat = saturdays[1];
        const lastSat = saturdays[saturdays.length - 1];

        // If we have valid dates in this month
        if (today <= lastSat) {
          return {
            secondSat,
            lastSat,
            monthOfEvent: monthToCheck,
            yearOfEvent: yearToCheck,
          };
        }
      }

      // Move to next month
      monthToCheck = (monthToCheck + 1) % 12;
      if (monthToCheck === 0) yearToCheck++;
      attempts++;
    }

    // Fallback - should theoretically never reach here
    const fallbackDate = new Date(today);
    fallbackDate.setDate(fallbackDate.getDate() + 7);
    return {
      secondSat: fallbackDate,
      lastSat: fallbackDate,
      monthOfEvent: fallbackDate.getMonth(),
      yearOfEvent: fallbackDate.getFullYear(),
    };
  };

  const { secondSat, lastSat, monthOfEvent, yearOfEvent } = getEventDates();

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };
  const monthOfTheLatestEvent = new Date(
    yearOfEvent,
    monthOfEvent,
    1
  ).toLocaleString("default", { month: "long" });
  const eventDates = [
    {
      date: secondSat,
      formattedDate: formatDate(secondSat),
      type: "second-saturday",
      hasPassed: today > secondSat,
      isUpcoming: today <= secondSat,
    },
    {
      date: lastSat,
      formattedDate: formatDate(lastSat),
      type: "last-saturday",
      hasPassed: today > lastSat,
      isUpcoming: today <= lastSat,
    },
  ];
const title = "Crafting Winning Resumes for Career Success!"
  return {
    subtitle: `Eraconneckt Resume Clinic,  ${monthOfTheLatestEvent} ${yearOfEvent}`,
    title: `Resume Clinic – ${title}`,
    time: "10 AM",
    currentEventDate: formatDate(today <= secondSat ? secondSat : lastSat),
    monthOfTheLatestEvent,
    yearOfTheLatestEvent: yearOfEvent,
    eventDates,
    flyerUrl:
      "https://res.cloudinary.com/bacf/image/upload/v1737463546/Eraconneckt/Image_bwmkyv.jpg",
    venue: "Microsoft Teams",
    description: `
    <p><strong>Welcome to the Resume Clinic – your first step towards landing the job you deserve!
</strong></p> 
    <p>Whether you're a fresh graduate, career changer, or professional looking to level up, our Resume Clinic is here to help you build a resume that gets noticed. We understand how competitive the job market is, and we're committed to making sure your application stands out with clarity, professionalism, and impact.
</p>



    <p><strong>🔍 What We Offer:</strong><br>
<ul>
<li> <strong>One-on-One Resume Reviews
</strong> <br/>
Get personalized feedback from career experts to optimize your resume layout, language, and tone.
</li>
<li> <strong> 
Resume Writing & Redesign Services
</strong><br/>

We help you restructure, rewrite, or completely revamp your resume from scratch, tailored to your industry and experience level.
</li>
<li> <strong> LinkedIn Profile Optimization</strong><br/>

Ensure your digital footprint is as strong as your CV. We help you align your resume and LinkedIn presence for greater visibility.
</li>
<li> <strong> ATS Compliance Check</strong><br/>

Many resumes don’t even get seen by a human. We’ll ensure your resume passes Applicant Tracking Systems (ATS) used by most employers.
</li>
</ul>
<strong>🎓 Upcoming Free Webinar: ${title}</strong> <br/>
<p>🗓 Date: ${formatDate(today <= secondSat ? secondSat : lastSat)}</p>

<p>🕒 Time: 10AM 

</p>
<p>📍 Location: Online (Microsoft Teams</p>
     `,
  };
};

export const jobRoleData = [
  {
    label: "Account Relationship Officer",
    value: "Account Relationship Officer",
  },
  { label: "Back-End Developer", value: "Back-End Developer" },
  { label: "Brand Identity Designer", value: "Brand Identity Designer" },
  { label: "Business Admin", value: "Business Admin" },
  { label: "Business Analyst", value: "Business Analyst" },
  { label: "Business Manager", value: "Business Manager" },
  { label: "Client Support Specialist", value: "Client Support Specialist" },
  { label: "Community Manager", value: "Community Manager" },
  {
    label: "Content/Social Media Management",
    value: "Content/Social Media Management",
  },
  { label: "Content Writer", value: "Content Writer" },
  { label: "Cyber Security Analyst", value: "Cyber Security Analyst" },
  { label: "Data Analyst", value: "Data Analyst" },
  { label: "DevOps Admin", value: "DevOps Admin" },
  { label: "DevOps Engineer", value: "DevOps Engineer" },
  { label: "Digital Marketing Intern", value: "Digital Marketing Intern" },
  { label: "Elementary School Teacher", value: "Elementary School Teacher" },
  { label: "Front-End Developer", value: "Front-End Developer" },
  { label: "Fullstack Developer", value: "Fullstack Developer" },
  { label: "Fundraiser", value: "Fundraiser" },
  { label: "Graphic Design Intern", value: "Graphic Design Intern" },
  { label: "HR Coordinator", value: "HR Coordinator" },
  { label: "HRIS Analyst", value: "HRIS Analyst" },
  { label: "HRIS Intern", value: "HRIS Intern" },
  { label: "Kitchen Assistant", value: "Kitchen Assistant" },
  { label: "Legal Research Intern", value: "Legal Research Intern" },
  { label: "Operations Admin", value: "Operations Admin" },
  { label: "Payroll Administrator", value: "Payroll Administrator" },
  { label: "Product Designer", value: "Product Designer" },
  { label: "Product Manager", value: "Product Manager" },
  { label: "Project Manager", value: "Project Manager" },
  { label: "Scrum Master", value: "Scrum Master" },
  { label: "Social Media Manager", value: "Social Media Manager" },
  { label: "System Admin", value: "System Admin" },
  { label: "Technical Writer", value: "Technical Writer" },
  { label: "Technician", value: "Technician" },
  {
    label: "Training Program Coordinator",
    value: "Training Program Coordinator",
  },
  { label: "UI/UX Designer", value: "UI/UX Designer" },
  { label: "Unskilled Labor", value: "Unskilled Labor" },
  { label: "UX Researcher", value: "UX Researcher" },
  { label: "Video Editor", value: "Video Editor" },
  { label: "Visual Designer", value: "Visual Designer" },
];

export const educationalQualification = [
  {
    label: "A Graduate",
    value: "Graduate",
  },
  {
    label: "An Undergraduate",
    value: "Undergraduate",
  },
  {
    label: "A SSCE Holder",
    value: "SSCE Holder",
  },
  {
    label: "Other",
    value: "Other(specify)",
  },
];

export const employmentStatus = [
  {
    label: "Employed",
    value: "Employed",
  },
  {
    label: "Unemployed",
    value: "Unemployed",
  },
  {
    label: "Freelancing",
    value: "Freelancing",
  },
  {
    label: "Interning",
    value: "Interning",
  },
  {
    label: "An Entrepreneur",
    value: "An Entrepreneur",
  },
];

export const jobSearchStatusData = [
  { label: "Actively searching", value: "actively_searching" },
  { label: "Open to opportunities", value: "open_to_opportunities" },
  { label: "Passively searching", value: "passively_searching" },
  { label: "Not searching", value: "not_searching" },
];

export const genderData = [
  {
    label: "Male",
    value: "Male",
  },
  {
    label: "Female",
    value: "Female",
  },
];
